// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/production_steps/remover
 *
 * Soft-deletes a production step (sets active = 0). Wire shape:
 * `dados: null` — empty success acknowledgement. Failure paths use
 * $this->sendError('...').
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionSteps_RemoverResponseDados = null;

export type ProductionSteps_RemoverResponse = ApiResponse<ProductionSteps_RemoverResponseDados>;

registerResponseContract('ProductionSteps_RemoverResponse', {})
